import { BaseService } from '../common/service/base.service';

export class BaseLandscapeServiceV3 extends BaseService {
  constructor(apiVersion: string = 'v3') {
    super(process.env.REACT_APP_LANDSCAPE_API_URL || '', apiVersion);
  }
}
